import React from 'react';
import equal from 'fast-deep-equal';
import FilesTile from '../FilesTile/FilesTile';

const FilesGroup = ({ data }) => {
  const { entries = [], change_logs = [] } = data;
  return (
    <div className='groupContainer'>
      {entries.length > 0
        ? entries.map((v, index) => {
            if (v.id !== 'Flyers') {
              return (
                <FilesTile
                  key={`content-${data.id}-${index}`}
                  title={v.name}
                  params={{
                    category: v.id,
                    series_id: data.id,
                  }}
                  change_logs={change_logs}
                />
              );
            }
          })
        : null}
    </div>
  );
};

export default React.memo(FilesGroup, equal);
